import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home mb-[60px]" }
const _hoisted_2 = ["src", "controls"]
const _hoisted_3 = { class: "mx-auto home-wrap w-[1200px] max-[750px]:w-[100%]" }

import CompanyActive from "@/components/HomeComp/CompanyActive.vue";
// import MienSwiper from "@/components/HomeComp/MienSwiper.vue";
import SwiperElegant from "@/components/HomeComp/swiperComp.vue";
import AboutComp from "@/components/HomeComp/AboutComp.vue";
import { onMounted, onUnmounted, ref } from "vue";
import useBanner from "@/hooks/useBanner";
import useGetDevice from "@/hooks/useGetDevice";
// import { ElMessage, ElMessageBox } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// import SwiperComp from "@/components/SwiperComp/IndexBannerSwiper.vue";
const videoUrl = ref("");
const videoRef = ref<HTMLVideoElement | null>(null);
const videoHeight = ref("auto");
const {
  versions: { isMobile },
} = useGetDevice();
const contrlBtn = ref<HTMLElement | null>(null);
useBanner(function (meneItem) {
  if (!meneItem.banner) return;
  meneItem.banner && (videoUrl.value = meneItem.banner);
  if (isMobile) {
    videoHeight.value = "auto";
  } else {
    videoHeight.value = window.innerHeight + "px";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "w-[100%]",
      style: _normalizeStyle({ height: videoHeight.value })
    }, [
      _createElementVNode("video", {
        src: videoUrl.value,
        class: "w-[100%] h-[100%] object-cover",
        loop: "",
        preload: "auto",
        autoplay: "",
        muted: "",
        controls: _unref(isMobile),
        ref_key: "videoRef",
        ref: videoRef
      }, null, 8, _hoisted_2)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CompanyActive),
      _createVNode(SwiperElegant, { class: "mt-[80px]" })
    ]),
    _createVNode(AboutComp)
  ]))
}
}

})